import termsAndConditions from '#frontend/util/termsAndConditions.js';

import template from './legalAgreement.html' with { type: 'html' };

export default {
	name: 'CLegalAgreement',
	props: {
		ctaText: {
			type: String,
			default: 'cart_submit'
		},
		customClass: {
			type: String,
			default: ''
		},
		order: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		},
		terms: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			hasScrollbar: false,
			notScrolled: true,
			finishedScrolling: false
		};
	},
	computed: {
		getTermsAndConditions() {
			return termsAndConditions(this.t, this.order, this.payment, this.theme, this.url, this.ctaText);
		},
		showDisclaimer() {
			return this.$store.getters.showDisclaimer;
		},
		showTermsTitle() {
			// Show title only for the trials in US
			return this.url.locale === 'en-us' && this.order.hasTrialProduct;
		}
	},
	mounted() {
		// Make sure that even on refresh, the calculation will be done correctly
		this.$nextTick(() => {
			const legalAgreementContainer = this.$refs.legalAgreement;
			if (legalAgreementContainer) {
				const containerHeight = legalAgreementContainer.offsetHeight;
				const scrollHeight = legalAgreementContainer.scrollHeight;
				// Check if there is any scrollbar, if zoom applied scrollHeight usually is rounded differently 1px diff
				this.hasScrollbar = containerHeight !== scrollHeight && containerHeight !== scrollHeight - 1 && containerHeight !== scrollHeight + 1;
				if (this.hasScrollbar) {
					legalAgreementContainer.addEventListener('scroll', this.handleScroll);
				}
				this.$store.commit('SET_TERMS_AGREEMENT', {
					checkbox: this.hasScrollbar || this.order.hasTermsCheckbox, // Show checkbox if there is a scrollbar or it's required to be displayed all the time
					accepted: !this.hasScrollbar && !this.order.hasTermsCheckbox && !this.isCustomId['CART-4095'], // Terms are automatically accepted if there is no scroll and CID is not CART-4095
					seen: this.terms && this.terms.seen
				});
			}
		});
	},
	destroyed() {
		const legalAgreementContainer = this.$refs.legalAgreement;
		if (legalAgreementContainer) {
			legalAgreementContainer.removeEventListener('scroll', this.handleScroll);
		}
		this.$store.commit('SET_TERMS_AGREEMENT', {
			checkbox: false,
			accepted: true,
			seen: this.terms && this.terms.seen
		});
	},
	methods: {
		handleScroll(event) {
			const container = event.target;
			const containerHeight = container.offsetHeight;
			const scrollHeight = container.scrollHeight;
			// Round to integer, when zoom applied the number is float, so it does not match
			const scrolledFromTop = Math.round(container.scrollTop);
			const scrollCalculation = scrollHeight - scrolledFromTop;
			// Scrollbar position is at the beginning (position 0)
			this.notScrolled = scrolledFromTop === 0;
			// Scrollbar position is at the end. In case there is any zoom applied, ignore 1px difference in rounding
			this.finishedScrolling = scrollCalculation === containerHeight || scrollCalculation - 1 === containerHeight || scrollCalculation + 1 === containerHeight;
		}
	},
	template
};
